import {SupportedLocale} from './types';

export const LOCALE_STORAGE_KEY = 'vc.locale';
export const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'es', 'fr', 'zh'];
export const FALLBACK_LOCALE: SupportedLocale = 'en';

export const normalizeLocale = (rawLocale?: string | null): SupportedLocale => {
    const raw = String(rawLocale || '').trim().toLowerCase().replace('_', '-');
    if (!raw) {
        return FALLBACK_LOCALE;
    }

    const short = raw.split('-')[0] as SupportedLocale;
    return SUPPORTED_LOCALES.includes(short) ? short : FALLBACK_LOCALE;
};

export const detectInitialLocale = (): SupportedLocale => {
    if (typeof window === 'undefined') {
        return FALLBACK_LOCALE;
    }

    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    if (saved) {
        return normalizeLocale(saved);
    }

    return normalizeLocale(window.navigator?.language);
};
